// Flame detector families are identified by the product-level `parentFamilies` metadata.
// Products are resolved via FgdsProductType.FLAME_DETECTOR, so no name-based heuristic is needed.
export class FlameDetectorType {
  static fromFamilyName(name: string, cantoImageId = ""): FlameDetectorType {
    return new FlameDetectorType(name, FlameDetectorType.toKey(name), cantoImageId);
  }

  static fromKey(key: string): FlameDetectorType {
    return new FlameDetectorType(key.replaceAll("_", " "), key, "");
  }

  private static toKey(name: string): string {
    return name.trim().replaceAll(/[^\p{L}\p{N}]+/gu, "_");
  }

  name: string;
  key: string;
  cantoImageId: string;

  constructor(name: string, key: string, cantoImageId: string) {
    this.name = name;
    this.key = key;
    this.cantoImageId = cantoImageId;
  }
}
